/**
 * Labstep
 *
 * @module components/ProtocolTimer/Action/Reset
 * @desc Action to reset timer to original time
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type React from 'react';
import type { IProtocolTimerActionResetProps } from './types';

export const ProtocolTimerActionReset: React.FC<
  IProtocolTimerActionResetProps
> = ({ protocolTimer, options, actionComponentProps }) => (
  <EntityActionUpdate
    entityName={protocolTimer.entityName}
    id={protocolTimer.idAttr}
    body={{
      paused_at: null,
      ended_at: null,
    }}
    options={options}
    actionComponentProps={actionComponentProps}
  />
);
